export default class TrackingService {

    constructor() {
        //fix npe if o tracking is not available
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            this.global.eventQBus = {
                emit: () => {
                }
            }
        }
    }

    sendViewTracking(featureOrder, featureIndex, promoType, brandTiles) {
        let trackingData = [this._createBrandShoppromoLabel(featureOrder, featureIndex, brandTiles.length, "loaded", promoType)];
        [].forEach.call(brandTiles, (tile, index) => {
            const brandPromoLabel = this._createBrandShoppromoTileLabel(index + 1, featureIndex, tile.dreson, tile.imageId, tile.urlPath, "loaded", promoType);
            trackingData.push(brandPromoLabel);
        });

        this.global.eventQBus.emit('tracking.bct.addFeaturesToPageImpression', trackingData);
    }

    sendClickTrackingEvent(legacyTrackingData, featureOrder, featureIndex, brandTile, position, filledSlots, promoType) {
        let trackingData = {
            name: "click",
            features: [this._createBrandShoppromoLabel(featureOrder, featureIndex, filledSlots, "clicked", promoType),
                this._createBrandShoppromoTileLabel(position, featureIndex, brandTile.dreson, brandTile.imageId, brandTile.urlPath, "clicked", promoType)]
        }
        let pageCluster = window.o_util.misc.getPagecluster();
        // Replace legacy tracking data with own object when old tracking is obsolete
        legacyTrackingData["wk.promo_AttributionFeature"] = `${promoType}_${pageCluster}`;
        legacyTrackingData["wk.promo_AttributionSource"] = "manual";

        this.global.eventQBus.emit('tracking.bct.submitMoveAction', legacyTrackingData, trackingData);
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": promoType});
    }

    _createBrandShoppromoLabel(featureOrder, featureIndex, filledSlots, status, promoType) {
        return {
            id: 'ft3_bspr' + this.getIdSuffix(promoType)  + featureIndex,
            name: promoType,
            position: featureOrder,
            status: status,
            labels: {
                promo_Feature: [true],
                promo_FilledSlots: [filledSlots],
                promo_FeatureNumber: [featureIndex + 1]
            }
        }
    }

    _createBrandShoppromoTileLabel(position, featureIndex, dreson, imageId, urlPath, status, promoType) {
        return {
            id: "ft3_bspr" + this.getIdSuffix(promoType) + featureIndex + "_tile" + position,
            parentId: "ft3_bspr" + this.getIdSuffix(promoType) + featureIndex,
            name: promoType + "-Tile",
            position: position,
            status: status,
            labels: {
                promo_Content: [urlPath],
                promo_TargetPsr: [dreson],
                promo_Source: ["manual"],
                promo_ImageId: [imageId]
            }
        };
    }

    getIdSuffix(promoType) {
        return (promoType === "BrandShopPromotionLarge") ? "la" : "sm";
    }
}
